<template>
  <div class="full-screen landing-page app-bg-gradient">
      <!-- <swiper :options="swiperOption" class="bg-img">
        <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" :class="(index === 2 ? 'heightFull' : '')"><img :src="slide" /></swiper-slide>
      </swiper> -->
      <!-- <div class="back-drop">
      </div> -->
      <!-- <img src="/static/images/epod-backdrop-img.jpg" class="background-image"/> -->
      <div class="stars"></div>
      <div class="logo-left-sec">
        <div class="bgimg">
          <img src="/static/images/backdrop-mosque.png" />
        </div>
        <img src="/static/images/logo.png" class="logo" />
        <ul>
          <li>lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml</li>
          <li>lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml</li>
          <li>lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml</li>
        </ul>
        <!-- <div class="quote">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pulvinar ipsum semper risus ultricies, quis molestie orci vehicula. Sed dignissim turpis fringilla turpis scelerisque, at efficitur nisi accumsan. Proin maximus sem sed porttitor molestie.</div> -->
      </div>
      <div class="landing-row-sec">
        <div class="mosque-login-details">
          <div class="login">
            <form class="form" v-on:submit.prevent='setTerminalId(tid)'>
              <div style="display: none;">
								<input type="hidden" name="_wpcf7" value="4" />
              </div>
              <div class="heading heding-color">SET TERMINAL</div>
              <div class="input-section top-mrgn input-btm-mrg">
                <img src="/static/images/password-icon.png">
                <input type="text" id="tid" name="tid" placeholder="Terminal-Id" v-model="tid">
              </div>
              <div class="btn-bg1">
                <div class="btn-bg2">
                  <button class="cursor login">{{"Set Terminal" | translate}}</button>
                </div>
              </div>
              <div v-if="errorMsg" class="error-msg">{{errorMsg | translate}}</div>
            </form>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import loginForm from './login-form.vue'

export default {
  name: 'Login',
  data () {
    return {
      userAction: 'login',
      errorMsg: false,
      tid: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'loginStatus'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus'
    ]),
    setTerminalId (a) {
      let vm = this
      if (a) {
        this.$router.push({path: `/${a}`})
      } else {
        vm.errorMsg = 'Enter valid terminal ID'
        setTimeout(() => {
          vm.errorMsg = false
        }, 3000)
      }
    }
  },
  components: {
    loginForm
  },
  mounted: function () {
    this.tid = this.$route.params.terminalId
    if (this.tid !== undefined) {
      this.$nextTick(() => {
      // Check wether the user has been already logged in.
        if (this.token) {
          // console.log(this.user)
          this.$router.push({path: `/${this.tid}/`})
          // this.$router.push({name: 'Home'}, (a) => console.log(arguments))
        } else {
          window.document.title = 'EPODTECH'
          this.changeLoadingStatus(false)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing-page {
  display: flex;
  /* background-image: url('/static/images/epod-backdrop-img.jpg'); */

  justify-content: space-between;
  position: relative;
}
.background-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
  .landing-row-sec {
    display: flex;
    width: 50%;
    justify-content: center;
  }
  .mosque-login-details {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
  .logo-left-sec {
    width: 50%;
  }
  .logo-left-sec .bgimg{
    position: absolute;
    width:100%;
    height: 100%;
    z-index: -1;
    bottom: 0;
    left:0;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
  }
  .logo-left-sec .bgimg img{
    margin-bottom: -100px;
  }
  div[dir='rtl'] .logo-left-sec .bgimg{
    right: 0;
  }
  .logo-left-sec .logo {
    margin-top: 15px;
    margin-left: 150px;
    width: 45%;
  }
  div[dir='rtl'] .logo-left-sec .logo {
    margin-right: 150px;
    margin-left: 0;
  }
  .logo-left-sec .quote {
    color: #812d03;
    max-width: 500px;
    text-align: center;
  }
  .mosque-login-details > div.login {
    width: 100%;
    height: 40vh;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 79px;
  }
  form {
    width: 50% !important;
    height: 100% !important;
    min-height: 400px !important;
    max-height: inherit !important;
  }
  .stars {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url('/static/images/background-stars.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    z-index: 1;
  }

  ul {
    list-style-type: circle;
    color: #812d03;
    opacity: 0.8;
    max-width: 450px;
    margin-left: 100px;
    margin-top: 30px;
  }
  ul li {
    margin-bottom: 16px;
  }

    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #812d03;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color: #812d03;
    }
    :-ms-input-placeholder { /* IE 10+ */
        color: #812d03;
    }
    :-moz-placeholder { /* Firefox 18- */
        color: #812d03;
    }
  .form {
    border-radius: 10px;
    background-color: rgba( 255, 255, 255,0.1 );
    width: 365px;
    height: 100%;
    padding: 36px 41px;
    position: relative;
    max-height: 550px;
    z-index: 2;
  }
  .input-section {
        width: 100%;
        position: relative;
    }
    .input-btm-mrg {
      margin-bottom: 45px;
    }
    .input-section img {
        width: 20px;
        position: absolute;
        top: 5px;
        left: 10px;
        z-index: 4
    }
    .input-section input {
        background: transparent;
        position: relative;
        vertical-align: top;
        border: none;
        border-bottom: 1px solid #812d03;
        display: -moz-inline-stack;
        display: inline-block;
        outline: none;
        height: 38px;
        width: 100%;
        padding: 0 15px;
        text-align: left;
        text-indent: 35px;
        font-size: 18px;
        font-family: 'Lato', sans-serif;
        color: #812d03;
    }

    div[dir='rtl'] .input-section input {
      text-align: right;
      text-indent: 5px;
    }
    @media only screen and (min-width: 2000px) {
      .input-section img {
        width:100px;
      }
      .input-section input {
        height: 150px;
        border-bottom-width: 5px;
        font-size: 80px;
        text-indent: 130px;
      }
      .logo-left-sec .logo {
        margin-top: 10%;
        margin-left: 15%;
      }
      div[dir='rtl'] .logo-left-sec .logo {
        margin-left: initial;
        margin-right: 15%;
      }
      .logo-left-sec .bgimg img {
        margin-bottom: 0;
        width: 60%;
      }
      ul {
        margin-left: 10%;
        margin-top: 10%;
        font-size: 80px;
        width: 70%;
        max-width: inherit;
        line-height: 80px;
      }
      div[dir='rtl'] ul {
        margin-left: initial;
        margin-right: 10%;
      }
      ul li {
        margin-bottom: 50px;
      }
      form {
        width: 60% !important;
      }
    }
  @media screen and (min-width: 1200px) and (min-height: 904px) {
    .logo-left-sec .bgimg img {
      margin-bottom: 0px;
    }
    .login .form-class {
      justify-content: flex-start;
    }
    form {
      max-height: 500px !important;
      width: 65% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/getTerminalId.vue